import { Button, Col, Row, Space } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import { useEffect, useState } from 'react';

interface RegisterFAComponent4Props {
  financialAsset: any[];
  onPrev: () => void;
  onNext: (data: any) => void;
}

function RegisterFAComponent4({
  financialAsset,
  onPrev,
  onNext,
}: RegisterFAComponent4Props) {
  const [selectedValues, setSelectedValues] = useState<any>([]);
  const columns: ColumnsType<any> = [
    {
      title: '이름',
      dataIndex: 'name',
    },
    {
      title: '번호',
      dataIndex: 'number',
    },
    // {
    //   title: '등록여부',
    //   dataIndex: 'isRegisted',
    // },
  ];

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelectedValues([...selectedRowKeys]);
    },
    selectedRowKeys: selectedValues,
    getCheckboxProps: (record: any) => ({
      disabled: record.disabled,
    }),
  };

  useEffect(() => {
    setSelectedValues([]);
  }, []);

  return (
    <>
      {financialAsset.length > 0 ? (
        <Row justify="center">
          <Col span={20}>
            <Table<any>
              rowKey="id"
              columns={columns}
              dataSource={financialAsset}
              rowSelection={{
                ...rowSelection,
                checkStrictly: false,
                type: 'checkbox',
              }}
              pagination={false}
            />
          </Col>
        </Row>
      ) : (
        <Row justify="center">
          <Col>
            <h3>카드가 존재하지 않습니다.</h3>
          </Col>
        </Row>
      )}

      <Row justify="center" style={{ marginTop: '50px' }}>
        <Space>
          <Button onClick={onPrev}>뒤로</Button>
          <Button
            onClick={() => {
              const financialAssetList: any[] = [];
              for (const selectedValue of selectedValues) {
                financialAssetList.push(financialAsset[selectedValue]);
              }
              onNext(financialAssetList);
              // onNext(financialAsset[selectedValues[0]]);
            }}
            disabled={selectedValues.length === 0}
          >
            등록하기
          </Button>
          {/* {financialAsset.length > 0 ? (
            <Button
              onClick={() => selectEnterprise(selectedValues)}
              disabled={selectedValues.length === 0}
            >
              회사선택하기
            </Button>
          ) : (
            <Button onClick={() => financialAsset()}>
              회사생성하기
            </Button>
          )} */}
        </Space>
      </Row>
    </>
  );
}
export default RegisterFAComponent4;
